import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {
  PAYMENT_LINK_IMAGES,
  PaymentLinkV2Campaign,
} from '@/app/main/paymentLink/models/constants/paymentLink.constants';
import {AppButton, AppButtonVariant} from '@/app/shared-components';

import {SplitsDisclaimer} from './SplitsDisclaimer';

interface SplitsLandingPromoCardProps {
  onOpenAccount: () => void;
}

export function SplitsLandingPromoCard({
  onOpenAccount,
}: SplitsLandingPromoCardProps) {
  const {t} = useTranslation();

  return (
    <Box className="splits-landing-card splits-landing-card-promo">
      <Typography className="splits-landing-promo-title">
        {t('split_bills_page.landing.promo_title', {
          amount: PaymentLinkV2Campaign.AMOUNT,
        })}
      </Typography>
      <Typography className="splits-landing-promo-description">
        {t('split_bills_page.landing.promo_description')}
      </Typography>
      <AppButton
        id="splits-landing-open-account"
        onClick={onOpenAccount}
        label={t('split_bills_page.landing.open_account')}
        variant={AppButtonVariant.onSecondary}
      />
      <Box className="splits-landing-promo-image-wrap">
        <Box
          component="img"
          className="splits-landing-promo-image"
          src={PAYMENT_LINK_IMAGES.MODAK_WEBSITE_V2_COMPOSITE.src}
          alt={PAYMENT_LINK_IMAGES.MODAK_WEBSITE_V2_COMPOSITE.alt}
          width={PAYMENT_LINK_IMAGES.MODAK_WEBSITE_V2_COMPOSITE.width}
          height={PAYMENT_LINK_IMAGES.MODAK_WEBSITE_V2_COMPOSITE.height}
        />
      </Box>
      <SplitsDisclaimer />
    </Box>
  );
}
